import createApiResponseSlice from '@redux-features/redux-slice';
import { configureStore } from '@reduxjs/toolkit';

const systemTemplatesSlice = createApiResponseSlice('systemTemplates');
const kibbutzTemplatesSlice = createApiResponseSlice('kibbutzTemplates');

export const systemTemplatesActions = systemTemplatesSlice.actions;
export const kibbutzTemplatesActions = kibbutzTemplatesSlice.actions;

const store = configureStore({
  reducer: {
    systemTemplates: systemTemplatesSlice.reducer,
    kibbutzTemplates: kibbutzTemplatesSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
